// extracted by mini-css-extract-plugin
export var closeButton = "Header_closeButton__m6mY2";
export var container = "Header_container__caUwq";
export var header = "Header_header__F9FZo";
export var shared = "\"../../../shared/shared.module.css\"";
export var sm = "576px";